export default __webpack_public_path__ + "locales/lv/Translations.json?hash=6a29589d4b8ea0287f6021975e0dc522";